// import { useState } from 'react';
import LocationIcon from '../../../assets/icons/consultants/location.svg';
import StarIcon from '../../../assets/icons/consultants/star.svg';
import LikeIcon from '../../../assets/icons/consultants/like.svg';
import CheckIcon from '../../../assets/icons/consultants/check.svg';
import EducationIcon from '../../../assets/icons/consultants/education.svg';
import { Col, FlexboxGrid, Button } from 'rsuite';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { handleGetAdminConsultantRegister } from '../../../api-handler/admin';
import { AdminConsultantRegisterModel } from '../../../models/admin';
import { CustomLoader } from './../../../components/basic/loader';
import { RequestConsultByUser } from './request-consult';
import { useUser } from '../../../contexts/user';

export const SingleConsultant = () => {
  // const [data, setData] = useState([1, 2, 3]);
  const { isUserRole } = useUser();
  const { username } = useParams();
  // const navigate = useNavigate();
  const [showRequestConsult, setShowRequestConsult] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<AdminConsultantRegisterModel>();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetAdminConsultantRegister(username ?? '');

      console.log(res);
      if (res.ok) {
        setData(res.data);
      }
      setLoading(false);
    })();
  }, [username]);

  return (
    <FlexboxGrid>
      <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%]">
        <div className="bg-[--rs-white] border-[--rs-primary-300] rounded-lg border-[1px] p-4 md:p-8 w-full">
          {loading ? (
            <CustomLoader />
          ) : data ? (
            <>
              <div className="flex">
                <div className="w-[100px] aspect-square rounded-full bg-[--rs-primary-50]"></div>
                <div className="mr-3 mt-2">
                  <h4 className="text-h4 text-[--rs-primary-800]">{data.FullName}</h4>
                  <p className="text-b1 mb-0 mt-1 text-[--rs-primary-400]">{data.Job}</p>
                  <div className="flex justify-between mt-2">
                    <div className="flex items-center">
                      <img src={StarIcon} alt="star" />
                      <span className="text-b2 text-[--rs-primary-500] mr-1">
                        <strong>4.9</strong> (21 نظر)
                      </span>
                    </div>
                    <div className="flex items-center mr-2">
                      <img src={LikeIcon} alt="like" />
                      <span className="text-b2 text-[--rs-success-800] mr-2">
                        100٪پیشنهاد کاربران
                      </span>
                    </div>
                    <div className="flex items-center mr-2">
                      <img src={CheckIcon} alt="check" />
                      <span className="text-b2 text-[--rs-info-700] mr-2">120 نوبت موفق</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center mr-auto mb-10">
                  <div className="flex items-center">
                    <img src={LocationIcon} alt="location" />
                    <p className="text-b1 text-[--rs-primary-400] ml-3">{data.City}</p>
                  </div>
                  <Button
                    appearance="primary"
                    className="mx-auto min-w-[50%] mb-2 inline-block"
                    type="button"
                    disabled={!isUserRole('User')}
                    // todo scroll down
                    onClick={() => setShowRequestConsult(true)}>
                    رزرو وقت مشاوره
                  </Button>
                </div>
              </div>
              <div className="flex items-center mt-6">
                <img src={EducationIcon} alt="education" />
                <p className="text-b1 text-[--rs-primary-400] mr-1 ">
                  {/* فارغ التحصیل رشته حقوق از دانشگاه تهران */}
                  {data.Education}
                </p>
              </div>
              <h5 className="text-h5 text-[--rs-primary-500] mt-5">درباره من</h5>
              <p className="text-b1 text-[--rs-primary-700] mt-1">{data.Description}</p>
            </>
          ) : null}
        </div>

        {showRequestConsult ? (
          <div className="bg-[--rs-white] border-[--rs-primary-300] rounded-lg border-[1px] p-4 md:p-8 w-ful mt-4">
            <RequestConsultByUser consultantUsername={username ?? ''} />
          </div>
        ) : null}
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};
